import React, { ReactNode } from 'react';
import { Dimensions, Modal, Platform } from 'react-native';

import { Box } from '@components/Restyle/index';
import theme from '@themes/theme';

export const ProjectChecklistCenterModal = ({
  visible,
  onClose,
  contentNode,
  width,
  padding,
}: {
  visible: boolean;
  onClose: () => void;
  contentNode: ReactNode;
  width?: number;
  padding?: keyof typeof theme.spacing;
}) => {
  const screenWidth = Dimensions.get('screen').width;
  return (
    <Modal
      transparent
      visible={visible}
      onRequestClose={onClose}
      animationType='fade'>
      <Box
        style={{
          flex: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Box
          flex={1}
          justifyContent='center'
          alignItems='center'
          p={padding ?? 'm'}>
          <Box
            backgroundColor='white'
            borderRadius='m'
            style={[
              { overflow: 'hidden' },
              Platform.OS === 'web' && { width: width ?? 483 },
              Platform.OS !== 'web' && {
                width: screenWidth - 32,
              },
            ]}>
            {contentNode}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
